import React, { useState, useRef, useCallback } from "react";
import { Segmented } from "antd";

import PcrPosRetest from "./PcrPosRetest";
import PcrPending from "./PcrPending";
import PcrPendingQueue from "./PcrPendingQueue";
// import PcrPlateMap from "./PcrPlateMap";
import PcrUploadXML from "./PcrUploadXML";
import "./PcrComponent.css";

const TAB_OPTIONS = [
  { value: "update-result", label: "Update Result" },
  { value: "retest", label: "Retest" },
  { value: "pending", label: "Pending" },
  { value: "upload-xml", label: "Upload XML" },
];

function PcrComponent({ history }) {
  const [activeTab, setActiveTab] = useState("update-result");

  const pcrPosRetestRef = useRef(null);
  const pcrRetestRef = useRef(null);
  const pcrPendingRef = useRef(null);
  const pcrUploadXMLRef = useRef(null);

  const handleChange = useCallback((newValue) => {
    if (newValue === "update-result" && pcrPosRetestRef.current) {
      pcrPosRetestRef.current.resetState();
    }
    if (newValue === "retest" && pcrRetestRef.current) {
      pcrRetestRef.current.fetchRetestRecords();
    }
    if (newValue === "pending" && pcrPendingRef.current) {
      pcrPendingRef.current.fetchPendingRecords();
    }
    if (newValue === "upload-xml" && pcrUploadXMLRef.current) {
      pcrUploadXMLRef.current.resetState();
    }
    setActiveTab(newValue);
  }, []);

  return (
    <div>
      <Segmented
        block
        className="CustomSegmented PcrSegmented"
        value={activeTab}
        options={TAB_OPTIONS}
        onChange={handleChange}
      />
      <div className={activeTab !== "update-result" ? "PcrTab--hidden" : ""}>
        <PcrPosRetest ref={pcrPosRetestRef} history={history} />
      </div>
      <div className={activeTab !== "retest" ? "PcrTab--hidden" : ""}>
        <PcrPending ref={pcrRetestRef} history={history} />
      </div>
      <div className={activeTab !== "pending" ? "PcrTab--hidden" : ""}>
        <PcrPendingQueue ref={pcrPendingRef} history={history} />
      </div>
      {/* <div className={activeTab !== "plate-map" ? "PcrTab--hidden" : ""}>
        <PcrPlateMap history={history} />
      </div> */}
      <div className={activeTab !== "upload-xml" ? "PcrTab--hidden" : ""}>
        <PcrUploadXML ref={pcrUploadXMLRef} history={history} />
      </div>
    </div>
  );
}

export default PcrComponent;
